import { environment } from './../environments/environment';
import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';
import { Router, RouterEvent, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { Global } from 'asap-crud';



@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    constructor(
        public auth: AuthService,
        public global: Global,
        public router: Router
    ) {

    }

    ngOnInit() {
        //localStorage.setItem('apiURL',"https://api.tecnologiaasap.com.br");
        localStorage.setItem('apiURL',environment.apiURL);
        localStorage.setItem("adonisURL","https://io.plataformaasap.com.br");

        this.restartData(location.href);

        this.router.events.subscribe((event: RouterEvent) => {
            this.navigationInterceptor(event)
        });

    }

    public restartData(url) {
        this.auth.params = this.getQueryParams(url);
        if (this.auth.params && this.auth.params.token) {
            const isSwitching = (this.auth.params && (this.auth.params.switch === 'true' || this.auth.params.switch === '1')) ||
                                (url && url.indexOf('switch=true') >= 0) ||
                                localStorage.getItem('asap_is_account_switching') === 'true' || 
                                sessionStorage.getItem('asap_is_account_switching') === 'true';

            sessionStorage.clear();
            const preserved: { [k: string]: string } = {};
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key) {
                    if (key.indexOf('asap_bi_') === 0 || key === 'asap_selected_language' || key === 'asap_certificate_base') {
                        const val = localStorage.getItem(key);
                        if (val) preserved[key] = val;
                    }
                    if (isSwitching && (key === 'asap_can_switch_accounts' || key === 'asap_master_client_id')) {
                        const val = localStorage.getItem(key);
                        if (val) preserved[key] = val;
                    }
                }
            }
            localStorage.clear();
            for (const k in preserved) {
                if (preserved[k]) {
                    localStorage.setItem(k, preserved[k]);
                }
            }
            if (isSwitching) {
                sessionStorage.setItem('asap_can_switch_accounts', 'true');
                localStorage.setItem('asap_can_switch_accounts', 'true');
                localStorage.setItem('asap_master_client_id', '20');
            }
            localStorage.setItem('apiURL', environment.apiURL);
            localStorage.setItem("adonisURL", "https://io.plataformaasap.com.br");
        }
    }

    public getQueryParams(route) {
        let uri = route.split("?");
        if (uri.length == 1) {
            return null;
        }
        else {
            let result: any = {}
            uri = uri[1];
            uri = uri.split("&");
            for (let params of uri) {
                let paramIdx = params.indexOf("=");
                let key = params.substring(0, paramIdx);
                let value = params.substring(paramIdx + 1);
                result[key] = decodeURIComponent(value);
            }
            return result;
        }
    }

    public navigationInterceptor(event: RouterEvent): void {

        if (event instanceof NavigationStart) {
            //this.blockUI.start('Carregando...');
            //if (!this.global.loggedUser()) {
                this.restartData(event.url);
            //}
        }

        if (event instanceof NavigationEnd) {
            //this.blockUI.stop()
        }

        // Set loading state to false in both of the below events to hide the spinner in case a request fails
        if (event instanceof NavigationCancel) {
            //this.blockUI.stop()
        }

        if (event instanceof NavigationError) {
            //this.blockUI.stop()
        }
    }

}
